import { ItemRect } from "conference/types";
import { styled } from "@mui/material/styles";
import { Video } from "@dvrt/web-phone-client";

export type SelfVideoDialogSettings = {
    rect: ItemRect;
    alwaysFloat: boolean;
};

export const defaultSelfVideoDialogSettings: SelfVideoDialogSettings = {
    rect: null,
    alwaysFloat: false,
};

export const MenuButton = styled("div")({
    position: "absolute",
    top: 6,
    right: 5,
    opacity: 0,
    cursor: "pointer",
    transition: "opacity 1s",
    fontSize: "1.2rem",
    padding: "0 6px",
    lineHeight: "40%",
});

export const PanelWrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    "&:hover .menuButton": {
        opacity: 0.9,
    },
});

export const Controls = styled("div")(({ theme }) => ({
    position: "absolute",
    bottom: 5,
    backgroundColor: "rgba(10, 10, 10, 0.6)",
    padding: 4,
    borderRadius: theme.shape.borderRadius,
    backdropFilter: "blur(4px)",
    color: "white",
    transition: "left 0.2s",
}));

export const VideoStyled = styled(Video)(({ theme }) => ({
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: theme.shape.borderRadius,
    transform: "scaleX(-1)",
}));
